import styled from 'styled-components'
import { fromPhone } from 'utilities/styled'
import TutorialBase from 'components/tutorial'

export const Tutorial = styled(TutorialBase)`
    ${fromPhone`
        margin-top: 64px;
    `}
`